module.exports = __webpack_public_path__ + "img/people.6b6bbe59.png";